import { Platform } from 'react-native'

// expo-notifications non è supportato sul web — import condizionale
let Notifications = null
if (Platform.OS !== 'web') {
  Notifications = require('expo-notifications')
}

// ─── Definizione categories ───────────────────────────────────────────
// Ogni category corrisponde a un tipo di notifica con bottoni specifici.
// Vengono registrate all'avvio dell'app — richiedono build nativa.

export const NOTIFICATION_CATEGORIES = {
  REMINDER_PICK: 'REMINDER_PICK',
  RESULTS:       'RESULTS',
  STARTLIST:     'STARTLIST',
  BADGE:         'BADGE',
  JERSEY:        'JERSEY',
}

export async function registerNotificationCategories() {
  // Le categories funzionano solo su mobile
  if (Platform.OS === 'web') return

  try {
    await Notifications.setNotificationCategoryAsync(NOTIFICATION_CATEGORIES.REMINDER_PICK, [
      {
        identifier: 'PICK_NOW',
        buttonTitle: '🚴 Pick ora',
        options: { opensAppToForeground: true },
      },
      {
        identifier: 'LATER',
        buttonTitle: 'Dopo',
        options: { opensAppToForeground: false, isDestructive: false },
      },
    ])

    await Notifications.setNotificationCategoryAsync(NOTIFICATION_CATEGORIES.RESULTS, [
      {
        identifier: 'VIEW_LEADERBOARD',
        buttonTitle: '🏆 Vedi classifica',
        options: { opensAppToForeground: true },
      },
    ])

    await Notifications.setNotificationCategoryAsync(NOTIFICATION_CATEGORIES.STARTLIST, [
      {
        identifier: 'PICK_NOW',
        buttonTitle: '🚴 Vai alla pick',
        options: { opensAppToForeground: true },
      },
    ])

    await Notifications.setNotificationCategoryAsync(NOTIFICATION_CATEGORIES.BADGE, [
      {
        identifier: 'VIEW_BADGE',
        buttonTitle: '🚲 Vedi badge',
        options: { opensAppToForeground: true },
      },
    ])

    await Notifications.setNotificationCategoryAsync(NOTIFICATION_CATEGORIES.JERSEY, [
      {
        identifier: 'VIEW_JERSEY',
        buttonTitle: '👕 Vedi maglia',
        options: { opensAppToForeground: true },
      },
    ])
  } catch (e) {
    console.warn('[notificationCategories] registerNotificationCategories error:', e)
  }
}

// ─── Handler tap bottoni notifica ────────────────────────────────────
// Chiamato quando l'utente preme un bottone (action) o apre la notifica.
// router e switchLeague vengono passati dall'esterno (dal _layout).

export function handleNotificationAction({ response, router, switchLeague }) {
  const { actionIdentifier, notification } = response
  const data = notification.request.content.data ?? {}

  const { id_race, id_league, category } = data

  // Se l'utente ha premuto "Dopo" o ha dismesso — non fare nulla
  const DEFAULT_ACTION = Notifications?.DEFAULT_ACTION_IDENTIFIER ?? 'com.apple.UNNotificationDefaultActionIdentifier'
  if (actionIdentifier === DEFAULT_ACTION && !category) return
  if (actionIdentifier === 'LATER') return

  const navigateWithLeague = async (path) => {
    if (id_league) await switchLeague(id_league)
    router.push(path)
  }

  switch (actionIdentifier) {
    case 'PICK_NOW':
      navigateWithLeague(id_race ? `/pick?id_race=${id_race}` : '/pick')
      break

    case 'VIEW_LEADERBOARD':
      navigateWithLeague(id_race ? `/leaderboard?id_race=${id_race}` : '/leaderboard')
      break

    case 'VIEW_BADGE':
      navigateWithLeague('/leagues')
      break

    case 'VIEW_JERSEY':
      navigateWithLeague('/')       // la Home mostra l'avatar con la maglia conquistata
      break

    // Tap diretto sulla notifica (nessun bottone) — naviga in base al tipo
    default:
      if (actionIdentifier === DEFAULT_ACTION) {
        switch (category) {
          case 'REMINDER_PICK':
          case 'STARTLIST':
            navigateWithLeague(id_race ? `/pick?id_race=${id_race}` : '/pick')
            break
          case 'RESULTS':
            navigateWithLeague(id_race ? `/leaderboard?id_race=${id_race}` : '/leaderboard')
            break
          case 'BADGE':
            navigateWithLeague('/leagues')
            break
          case 'JERSEY':
            navigateWithLeague('/')
            break
          default:
            break
        }
      }
      break
  }
}